// This file is auto-generated by Lovable. Do not modify it.
// Manual guard added: on native (Capacitor iOS/Android) we do NOT initialize
// the OAuth wrapper — its full-page `window.location.href` handoff would
// bounce the user to Safari/Chrome and Apple review flags that as a
// Guideline 4.0 / 2.1 violation. Web is unchanged.

import { createLovableAuth } from "@lovable.dev/cloud-auth-js";
import { supabase } from "../supabase/client";

function isNativeCapacitor(): boolean {
  try {
    // @ts-ignore — injected by native bridge
    const cap = (globalThis as any)?.window?.Capacitor;
    return !!(cap && typeof cap.isNativePlatform === "function" && cap.isNativePlatform());
  } catch {
    return false;
  }
}

const lovableAuth = isNativeCapacitor() ? null : createLovableAuth();

type SignInOptions = {
  redirect_uri?: string;
  extraParams?: Record<string, string>;
};

export const lovable = {
  auth: {
    signInWithOAuth: async (provider: "google" | "apple", opts?: SignInOptions) => {
      if (!lovableAuth) {
        return {
          error: new Error(
            "OAuth sign-in is not available inside the native app. Please use email and password."
          ),
        };
      }

      const result = await lovableAuth.signInWithOAuth(provider, {
        redirect_uri: opts?.redirect_uri,
        extraParams: {
          ...opts?.extraParams,
        },
      });

      if (result.redirected) {
        return result;
      }

      if (result.error) {
        return result;
      }

      try {
        await supabase.auth.setSession(result.tokens);
      } catch (e) {
        return { error: e instanceof Error ? e : new Error(String(e)) };
      }
      return result;
    },
  },
};
